













































































	import { Vue, Component, Prop, ObjectTypesHelper } from "../../Infrastructure/CorBase/CoreBase";
	import TagModal from "./BaseTLModalDialogTag.vue";
	import ModalDetail from "./BaseTLModalDialogDetail.vue";

	@Component
	export default class BaseTLGridItem extends Vue {
		@Prop({ type: String, required: false, default: "" }) design?: string; //typ designu co se zobrazi typy: GridMedia, GridReceiver
		@Prop({ type: Number, required: false, default: 0 }) id?: number; //id
		@Prop({ type: String, required: false, default: "" }) description1?: string; //popisek v obrazku  nejvice dole
		@Prop({ type: String, required: false, default: "" }) description2?: string; //popisek v obrazku na ním
		@Prop({ type: String, required: false, default: "" }) typeFile?: string; //typ souboru
		@Prop({ type: String, required: false, default: "" }) name?: string; //název souboru
		@Prop({ type: String, required: false, default: "" }) nameTask?: string; //název úlohy
		@Prop({ type: String, required: false }) taskList?: any; //seznam úloh
		@Prop({ type: Number, required: false, default: 0 }) idTask?: number; //idTasku
		@Prop({ type: Boolean, required: false, default: false }) selected?: boolean; //vybráno
		@Prop({ type: Array, required: false }) tags!: any[]; //tagy
		@Prop({ required: true }) item: any; //zakladni jeden prvek
		@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.None }) objectType!: ObjectTypesHelper.ObjectTypeEnum;
		tagItems: any;
		showAllTask = false;

        mediaParameters() {
			return (this.item.idContentVariantParameters as string).replace(/#a#/g," ");
		}

		created() {
			this.tagItems = this.tags;
		}

		getTypeModalTag() {
			var resutl = this.design == 'GridMedia' ? "content" : "receiver";
			return resutl;
		}

		detailPage() {
			var detailPage = this.design == 'GridReceiver' ? 'ReceiverDetail' : 'ContentDetail';
            this.$router.push({ name: detailPage, params: { id: this.item.id.toString() }, query: { id: this.item.id.toString() } });
		}

        deletePage() {
            this.$emit('deleteClick', this.item.id);
        }

		goBackDetailTag(item: any): void {
			this.$emit('goBackTagDetail', item);
		}

		tagDetail(item: any): void {
			this.$emit('detailTag', item);
			//puvodni ale detail uz nechceme
			//this.$bvModal.show(this.idModalDialog());
			//(this.$refs.detailModal as ModalDetail).setSelected(String(item.id));
		}

		gridColor(color: string): string {
            return 'background-color: ' + color + ';';
		}

		getPreviewId(id: number | null | undefined): string {
			if (id && id > 0) {
				if (ObjectTypesHelper.isContentObjectType(this.objectType)) {
					return `image_grid_content_${id}`;
				}
				if (ObjectTypesHelper.isReceiverObjectType(this.objectType)) {
					return `image_grid_receiver_${id}`;
				}
			}
			return `image_grid_0`;
		}

		allItems() {
			return this.tagItems;
		}

		changeTags(items: any): void {
			this.tagItems = items;
			this.$forceUpdate();
		}

		idModalDialog() {
			return 'modalDialog' + this.id;
		}

		idTagModal() {
			return 'tagModalDialog' + this.id;
		}

		lastIdComponent = 0;
		addNewTag() {
			this.$bvModal.show(this.idTagModal());
			(this.$refs.idTagModalGrid as TagModal).setSelected(this.tagItems, Number(this.id), this.item.name);
		}


		inputClass(): string {
			return this.selected ? 'gridMainSelected' : 'gridMain';
		}

		selectItem() {
			this.$emit('selectItemGrid', this.id);
		}

		getTaskName() {
			let name = this.item.taskList.length > 0 ? this.item.taskList[0].name : '';
            return name.length > 23 ? name.substring(0, 23) + '...' : name;
		}

        getTaskNameList() {
 			var result = [];
			if (this.item.taskList.length > 1) {
				for (var i = 1; i < this.item.taskList.length; i++) {
					result.push(this.item.taskList[i]);
				}
			}
			return result;
        }

		getDescription1(): string {
			var result = this.description1 == undefined ? '' : String(this.description1);
			return result.length > 15 ? result.substring(0, 23) + '...' : result;
		}

		tooltip(): string {
			var result = this.taskList == undefined ? '' : String(this.taskList);
			return result;
		}

        showActivityColor() {
			var result = " ";
			switch (this.item.idComponentStateNavigation) {
				case "ENU_COR_Component_State_Active":
                    result += "receiverStatusActive";
					break;
                case "ENU_COR_Component_State_Activating":
                    result += "receiverStatusActive";
					break;
                case "ENU_COR_Component_State_New":
                    result += "receiverStatusNew";
					break;
                case "ENU_COR_Component_State_Provisioned":
                    result += "receiverStatusLost";
					break;
                case "ENU_COR_Component_State_Provisioning":
                    result += "receiverStatusLost";
					break;     
                case "ENU_COR_Component_State_Lost" || "ENU_COR_Component_State_Stopping" :
                    result += "receiverStatusLost";
                    break; 
            	}

            return result + " gridIconsReciverActive";
		}

		showToolTip(): boolean {
			var result = this.taskList == undefined ? '' : String(this.taskList);
			return result.split('<br/>').length > 2;
		}

		//VaP - zde nechame vybublat akci nahoru, bohuzel to musime udelat skrz BaseTLGrid.vue a BaseTLTable.vue az do prislusne Listove komponenty, ktera si s tim poradi, ale porad lepsi nez mit zde natvrdo nadefinovane, jak se prejde na konkretni detail objektu z gridu
		//    - a tim padem to mit nadefinovane na dvou mistech soucasne
		//VaPTODO - po migraci na vue 3, pokud nebude lepsi zpusob, tak je jeste moznost predelat bublani skrz 4 vue komponenty na bus viz druha cast teto odpovedi
		//        - https://stackoverflow.com/a/42032163
		actionDetails() {
			var id = this.id == undefined ? 0 : this.id;
			this.$emit('detailClick', id);
		}

		goToTaskDetail() {
			this.$router.push({ name: 'TaskDetail', params: { id: this.item.taskList[0].id }, query: { id: this.item.taskList[0].id } });
		}

        goToTaskDetailItem(item:any) {
            this.$router.push({ name: 'TaskDetail', params: { id: item.id }, query: { id: item.id } });
        }

		getImagePreviewStaticId(item: any) {
			if (ObjectTypesHelper.isContentObjectType(this.objectType)) {			
				if (item.idContentPreviewGridStatic) {
					return item.idContentPreviewGridStatic;
				}
			}
			if (ObjectTypesHelper.isReceiverObjectType(this.objectType)) {
				if (item.id) {
					return item.id;
				}
			}
			return 0;
		}

		getImagePreviewAnimatedId(item: any) {
			if (ObjectTypesHelper.isContentObjectType(this.objectType)) {
				if (item.idContentPreviewGridAnimated) {
					return item.idContentPreviewGridAnimated;
				}
			}
			return 0;
		}
	}
